import { useAuth } from '@nvision/oidc';

export const useIdentityAuth = () => {
  return useAuth();
};
